<template>
  <div class="mobile-layout">
    <van-nav-bar
      :title="pageTitle"
      :left-arrow="showBack"
      fixed
      placeholder
      safe-area-inset-top
      @click-left="onBack"
    >
      <template #right>
        <span class="nav-user" @click="showUser = true">{{ user.username }}</span>
      </template>
    </van-nav-bar>

    <div class="mobile-body">
      <slot />
    </div>

    <van-tabbar
      :value="activeMenu"
      active-color="#1989fa"
      inactive-color="#7d7e80"
      safe-area-inset-bottom
      @change="onTabChange"
    >
      <van-tabbar-item
        v-for="item in tabs"
        :key="item.name"
        :name="item.name"
        :icon="item.icon"
      >
        {{ item.label }}
      </van-tabbar-item>
    </van-tabbar>

    <van-action-sheet
      v-model="showUser"
      :actions="userActions"
      cancel-text="取消"
      close-on-click-action
      @select="onUserAction"
    />
  </div>
</template>

<script>
const TABS = [
  { name: 'home', label: '首页', icon: 'home-o' },
  { name: 'system-recommend', label: '推荐', icon: 'fire-o' },
  { name: 'window-ranking', label: '雷达', icon: 'scan' },
  { name: 'trend-king', label: '趋势', icon: 'chart-trending-o' },
  { name: 'more', label: '更多', icon: 'bars' },
]

export default {
  name: 'MobileLayout',
  props: {
    user: { type: Object, required: true },
    activeMenu: { type: String, required: true },
    pageTitle: { type: String, required: true },
    showBack: { type: Boolean, default: false },
  },
  data() {
    return {
      tabs: TABS,
      showUser: false,
      userActions: [{ name: '退出登录' }],
    }
  },
  methods: {
    onTabChange(name) {
      this.$emit('select', name)
    },
    onBack() {
      if (!this.showBack) return
      this.$emit('back')
    },
    onUserAction(action) {
      if (action && action.name === '退出登录') this.$emit('logout')
    },
  },
}
</script>

<style scoped>
.mobile-layout {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f7f8fa;
  box-sizing: border-box;
}

.mobile-body {
  padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));
  min-height: calc(100vh - 46px);
  min-height: calc(100dvh - 46px);
  box-sizing: border-box;
}

.nav-user {
  font-size: 13px;
  color: #1989fa;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
</style>
